import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import '@/App.css';
import PublicLayout from '@/components/layout/PublicLayout';
import AdminLayout from '@/components/layout/AdminLayout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Blog from '@/pages/Blog';
import BlogDetail from '@/pages/BlogDetail';
import Gallery from '@/pages/Gallery';
import Contact from '@/pages/Contact';
import MediaCenter from '@/pages/MediaCenter';
import Transparency from '@/pages/Transparency';
import AdminLogin from '@/pages/AdminLogin';
import AdminOverview from '@/pages/admin/AdminOverview';
import AdminProjects from '@/pages/admin/AdminProjects';
import AdminBlogs from '@/pages/admin/AdminBlogs';
import AdminGallery from '@/pages/admin/AdminGallery';
import AdminMedia from '@/pages/admin/AdminMedia';
import AdminMessages from '@/pages/admin/AdminMessages';
import Founder from '@/pages/Founder';
import Donate from '@/pages/Donate';
import Policy from '@/pages/Policy';
import { useAuth } from '@/lib/auth';

function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-ukgm-slate">Loading…</div>;
  }
  if (!user || user.role !== 'admin') {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}

export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/media" element={<MediaCenter />} />
          <Route path="/transparency" element={<Transparency />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/policy/:kind" element={<Policy />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedAdmin><AdminLayout /></ProtectedAdmin>}>
          <Route index element={<AdminOverview />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="blogs" element={<AdminBlogs />} />
          <Route path="gallery" element={<AdminGallery />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="messages" element={<AdminMessages />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
